import React from 'react'
import InitContainers from './containers/InitContainers'

function App(props) {
  return (
    <div className="App">
      <header className="App-header">
        <InitContainers />
      </header>
    </div>
  )
}

export default App
